import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminUserTestsRoutes: RouteObject[] = [
  {
    path: 'admin/user-tests',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_USER_TESTS, title: 'Assignations' },
  },
  {
    path: 'admin/user-tests/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_USER_TEST_FORM, title: 'Nouvelle assignation' },
  },
  {
    path: 'admin/user-tests/:userTestKey',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_USER_TEST_DETAIL, title: 'Détail assignation' },
  },
];
